// test1104
(1104 && 0);
